// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1sRz7","questions":"styles_questions__1ZIvr","footer":"styles_footer__1D2Lk"};